import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Ballot } from "@material-ui/icons";
import { Grid, Typography, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DataOrModifiedFn } from "use-async-resource";
import noProjects from "../../../../assets/images/noProject.svg";
import { ResultOfIListOfProjectDto } from "../../../api/APIClient";
import ProjectCard from "./ProjectCard";
import { BDTRoutes } from "../../../helpers/applicationConstants";
import { Button } from "../../Common/Components/GenericComponents/v4/Button";

const useStyles = makeStyles(() => ({
    logo: {
        maxHeight: "40vh",
        width: "80vw",
        opacity: "0.5",
        marginBottom: "50px",
        marginTop: "50px",
    },
    box: {
        position: "sticky",
        marginBottom: "12px",
    },
    link: {
        textDecoration: "none",
        color: "white",
    },
}));

const ProjectsList = ({
    projectsReader,
}: {
    projectsReader: DataOrModifiedFn<ResultOfIListOfProjectDto>;
}): JSX.Element => {
    const { t } = useTranslation("main");
    const classes = useStyles();
    const projects = projectsReader();

    if (projects.data.length > 0) {
        const renderProjects = projects.data.map((project) => (
            <Grid item xs={12} sm={6} md={4} key={project.id}>
                <ProjectCard project={project} />
            </Grid>
        ));

        return (
            <>
                <Box className={classes.box}>
                    <Button startIcon={<Ballot />} variant="contained" color="primary">
                        <Link className={classes.link} to={BDTRoutes.Administration.Projects}>
                            {t("projects.manage")}
                        </Link>
                    </Button>
                </Box>

                <Grid
                    container
                    alignContent="flex-start"
                    alignItems="center"
                    direction="row"
                    justify="flex-start"
                >
                    {renderProjects}
                </Grid>
            </>
        );
    }

    return (
        <Grid
            container
            alignContent="center"
            alignItems="center"
            justify="center"
            direction="column"
        >
            <Grid item style={{ textAlign: "center" }}>
                <img className={classes.logo} src={noProjects} alt="no projects pic" />
            </Grid>
            <Grid item style={{ textAlign: "center" }}>
                <Typography variant="h4" paragraph>
                    {t("projects.noProjects")}
                </Typography>
                <Link to={BDTRoutes.Administration.Projects}>
                    <Typography variant="h6">{t("projects.createFirstProject")}</Typography>
                </Link>
            </Grid>
        </Grid>
    );
};

export default ProjectsList;
